import { Asset } from "../../../../../../../services/asset/types/asset";
import { Release } from "../../../../../../../common/types/release/release";
import { SimpleRelease } from "../../../../../../../common/types/release/simple-release";
import { ReleaseStatus } from "../../../../../../../common/types/release/relase-status";
import { BackofficeUserTier } from '../../../../../../../services/release-admin/types/backoffice-user-tier';
import SimpleTrack from "../../../../../../../common/types/release/simple-track";
import { routes } from '../../../../routes';
import { Macro } from "../../../../../../../services/macros/types/macros";

export interface DetailActionProps {
  status: ReleaseStatus;
  data: {
    release: Release | SimpleRelease;
    assets?: Asset<any>[];
    tracks?: SimpleTrack[]
  }[];
  onAction: (ids: string[]) => void;
  default?: string;
  tier?: BackofficeUserTier;
  macros?: Macro[]
}

export const getNextPage = (from?: string) => {
  if (from === 'release-list') {
    return routes.releases.list;
  }
  return routes.inbox.list;
}